import React from 'react';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';
import { useI18n } from 'hooks/use_i18n';
import { Modal, Button } from 'components/ui';
import { Row, Col } from 'components/ui/grid';
import './confirm_modal.scss';

const ConfirmModal = ({ show, proceed, dismiss, cancel, options }) => {
  const { t } = useI18n();

  const defaultOptions = {
    title: t('components.ui.confirm_modal.title'),
    cancelButtonText: t('components.ui.confirm_modal.answer_no'),
    proceedButtonText: t('components.ui.confirm_modal.answer_yes'),
    cancelButtonColor: 'primary',
    proceedButtonColor: 'primary',
    withCancelButton: true,
  };
  const finalOptions = { ...defaultOptions, ...options };

  return (
    <Modal
      centered
      isOpen={show}
      onClosed={dismiss}
      returnFocusAfterClose={false}
      title={finalOptions.title}
      className="confirm-modal"
      footer={
        <div className="d-flex justify-end">
          {finalOptions.withCancelButton && (
            <Button
              color={finalOptions.cancelButtonColor}
              onClick={cancel}
              block
              className="mr-2"
            >
              {finalOptions.cancelButtonText}
            </Button>
          )}
          <Button
            color={finalOptions.proceedButtonColor}
            onClick={proceed}
            block
            className="mt-0"
          >
            {finalOptions.proceedButtonText}
          </Button>
        </div>
      }
    >
      <div className="text-center">
        {finalOptions.message && <p className="my-3">{finalOptions.message}</p>}
      </div>
    </Modal>
  );
};

ConfirmModal.defaultProps = {
  show: false,
  proceed: null,
  cancel: null,
  dismiss: null,
  options: {},
};

ConfirmModal.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  cancel: PropTypes.func,
  dismiss: PropTypes.func,
  options: PropTypes.object,
};

export default confirmable(ConfirmModal);
